var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 192,
    viewBox: "0 0 336 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.621 180.123C151.697 255.124 -48.881 -64.1047 11.7419 -18.8292C171.731 100.657 124.491 -42.0721 154.573 -49.51L154.611 -49.5326C154.57 -49.5152 154.525 -49.4963 154.644 -49.5517C154.644 -49.55 154.645 -49.5482 154.645 -49.5465C187.473 70.4752 295.062 -33.0561 325.448 -16.3089C363.431 4.62551 279.03 55.3167 235.164 69.43C191.299 83.5433 188.138 140.881 175.621 180.123Z",
    fill: "url(#paint0_linear_619_1578)",
    fillOpacity: 0.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_619_1578",
    x1: 319.731,
    y1: -55.5242,
    x2: 7.37641,
    y2: 47.0215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7750BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7750BF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleAbout);
export default __webpack_public_path__ + "static/media/PurpleAbout.9b10fa336d785c2153c09c74ac13b2e5.svg";
export { ForwardRef as ReactComponent };